import { API_CONFIG } from '../../../config/api.config'

const API_ROOT = API_CONFIG.python.apiUrl

function getToken(): string {
  return (
    localStorage.getItem('jwt_token') ||
    localStorage.getItem('auth_token') ||
    localStorage.getItem('token') ||
    ''
  )
}

async function req<T>(path: string): Promise<T> {
  const res = await fetch(`${API_ROOT}${path}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  })
  if (!res.ok) {
    const detail = await res.text().catch(() => '')
    throw new Error(`API ${res.status}: ${detail}`)
  }
  return res.json()
}

export type LearningLevel = 'weak' | 'at_risk' | 'pass' | 'good' | 'excellent' | 'unknown' | 'no_data' | 'linked_no_data'

export interface LearningRecommendation {
  priority: 'high' | 'medium' | 'low' | 'maintain' | string
  reason: string
  actions: string[]
  topic_code?: string
  resource_title?: string
  source?: string
  percent?: number
  level?: LearningLevel
  last_event?: string
}

export interface StudentInterventionRow {
  student_id?: string | null
  student_email?: string
  student_name?: string
  class_name?: string
  events: number
  avg_percent?: number | null
  latest_event?: string | null
  weak_count: number
  status: LearningLevel
  recommendations: LearningRecommendation[]
}

export interface WeakTopic {
  topic_code: string
  topic_title?: string
  count: number
  students: number
}

export interface QuestionIssue {
  question_id: string
  question?: string
  wrong_count: number
  resource_title?: string
}

export interface TeacherClassDashboard {
  class_name?: string | null
  summary: {
    students: number
    linked: number
    events: number
    weak_or_at_risk: number
  }
  students: StudentInterventionRow[]
  weak_topics: WeakTopic[]
  question_issues: QuestionIssue[]
}

export const learningApi = {
  teacherClassDashboard(className?: string): Promise<TeacherClassDashboard> {
    const qs = className ? `?class_name=${encodeURIComponent(className)}` : ''
    return req<TeacherClassDashboard>(`/learning/teacher/class-dashboard${qs}`)
  },
  myRecommendations(): Promise<{ items: LearningRecommendation[]; count: number }> {
    return req<{ items: LearningRecommendation[]; count: number }>('/learning/me/recommendations')
  },
}
